import React from 'react';
import classNames from 'classnames';
import { AvatarLarge } from '../../../components';

import css from './SectionAuthorCustom.module.css';

const SectionAuthorCustom = ({ rootClassName, author }) => {
  const classes = classNames(rootClassName || css.root);

  const scrollToUserProfile = () => {
    const element = document.getElementById('author');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  }

  return (
    <div className={classes} onClick={scrollToUserProfile}>
      <div className={css.wrapper}>
        <AvatarLarge user={author} disableProfileLink />
        <div className={css.authorName}>{author.attributes.profile.displayName}</div>
      </div>
    </div>
  );
};

export default SectionAuthorCustom;
